
import { Canvas, Rect, Text, Group } from "fabric";
import { pixelsToMillimeters } from "@/utils/measurement-utils";
import { MeasurementService } from "@/services/measurement-service";
import { ShapeType, CustomFabricObject } from "@/types/fabric";

export const updateRectangleMeasurements = (rect: Rect, widthLabel: Text | Group, heightLabel: Text | Group, canvas: Canvas) => {
  if (!rect) return;

  const parent = rect.group;
  const parentScaleX = parent ? (parent.scaleX || 1) : 1;
  const parentScaleY = parent ? (parent.scaleY || 1) : 1;

  const width = rect.width! * parentScaleX;
  const height = rect.height! * parentScaleY;

  const widthMm = Math.round(pixelsToMillimeters(width, canvas));
  const heightMm = Math.round(pixelsToMillimeters(height, canvas));

  // Use the service to update measurement texts
  MeasurementService.updateMeasurementText(widthLabel, `${widthMm}mm`);
  MeasurementService.updateMeasurementText(heightLabel, `${heightMm}mm`);

  // Get current zoom for proper scaling
  const zoom = canvas.getZoom();
  
  // Update measurement scaling
  MeasurementService.updateMeasurementScaling([widthLabel, heightLabel], zoom);

  canvas.renderAll();
};

export const createMeasuredRectangle = (
  canvas: Canvas, 
  width: number, 
  height: number, 
  props: any, 
  shapeType: 'square' | 'rectangle' = 'rectangle'
) => {
  const rect = new Rect({
    ...props,
    width,
    height,
  });

  const widthMm = Math.round(pixelsToMillimeters(width, canvas));
  const heightMm = Math.round(pixelsToMillimeters(height, canvas));

  // Get current zoom for scaling
  const zoom = canvas.getZoom();

  // Position width label above the top edge with consistent offset
  const widthPosition = {
    x: props.left + width / 2,
    y: props.top - 12, // Consistent offset
    angle: 0
  };
  
  // Position height label to the left of the left edge with consistent offset
  const heightPosition = {
    x: props.left - 12, // Consistent offset
    y: props.top + height / 2,
    angle: -90
  };

  // Use our measurement service to create labels
  const widthLabel = MeasurementService.createMeasurementLabel(
    `${widthMm}mm`,
    widthPosition.x,
    widthPosition.y,
    widthPosition.angle,
    true,
    zoom
  );

  const heightLabel = MeasurementService.createMeasurementLabel(
    `${heightMm}mm`,
    heightPosition.x,
    heightPosition.y,
    heightPosition.angle,
    true,
    zoom
  );

  // Create the measured group using our service
  const group = MeasurementService.createMeasurementGroup(
    rect, 
    [widthLabel, heightLabel], 
    canvas, 
    shapeType
  );
  
  return group;
};
